// ----------------------------------------------------------------------
// <copyright file="Izenda.MyPreferenceActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var compose = require('recompose').compose;
  var withHandlers = require('recompose').withHandlers;
  var UiState = require('logic/Izenda.UiState');
  const { curry, isNil } = require('lodash/fp');
  var MyPreferenceActions = compose(
    withHandlers({
      updateValue: curry(updateValue),
      resetDataOffset: curry(resetDataOffset),
      resetTimestampOffset: curry(resetTimestampOffset)
    })
  );

  /**
   * Toggle section
   * @param {Object} props
   * @param {String} props name
   */
  function updateValue(props, key, element) {
    props.store.model.updateProperty(key, isNil(element.target) ? element : element.target.value);
  }

  /**
   * Reset data offset
   * @param {Object} props
   */
  function resetDataOffset(props) {
    props.store.model.updateProperty('dataOffset', UiState.currentUser.dataOffset);
  }

  /**
   * Reset timestamp offset
   * @param {Object} props
   */
  function resetTimestampOffset(props) {
    props.store.model.updateProperty('timestampOffset', UiState.currentUser.timestampOffset);
  }

  module.exports = MyPreferenceActions;
})();



// WEBPACK FOOTER //
// ./ui/modules/MyProfile/MyPreference/Izenda.MyPreferenceActions.js